var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "menuLeft", staticClass: "layout" }, [
    _c("img", {
      staticClass: "ip_logo",
      attrs: { src: require("@/assets/images/login/ip_logo.png"), alt: "logo" },
      on: { click: _vm.toHomePage }
    }),
    _vm._v(" "),
    _vm.menu
      ? _c(
          "div",
          { staticClass: "menu" },
          [
            _c("ComplianceBrainMenu"),
            _vm._v(" "),
            _vm._l(Object.entries(_vm.menu), function(ref) {
              var key = ref[0]
              var group = ref[1]
              return _c("MenuGroup", { key: key, attrs: { group: group } })
            })
          ],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-69d7a26c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69d7a26c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/menuLeft.vue
// module id = null
// module chunks = 